export default {
  quiz: {
    title: {
      en: 'Let’s get personal',
    },
    actionText: {
      en: 'Take our fragrance quiz',
    },
  },
  collections: {
    title: {
      en: 'Need some ideas?',
    },
    actionText: {
      en: 'Browse our curated collections',
    },
  },
  home: {
    title: {
      en: 'Cozy at home',
    },
    actionText: {
      en: 'Our latest home fragrances',
    },
  },
  theEdit: {
    title: {
      en: 'The Edit',
    },
    actionText: {
      en: 'Explore home fragrances',
    },
  },
}
